import React, { useState, useEffect } from 'react';

const GoogleReviews = () => {
  const [reviews, setReviews] = useState([
    {
      id: 1,
      author: "Sarah M.",
      rating: 5,
      date: "2 days ago",
      text: "Amazing service! The package scanning system made pickup so easy. Staff was very helpful and professional.",
      verified: true
    },
    {
      id: 2,
      author: "Mike R.", 
      rating: 5,
      date: "1 week ago",
      text: "Love the new barcode system. No more waiting in lines - just scan and go! Ashop has really innovated package management.",
      verified: true
    },
    {
      id: 3,
      author: "Jennifer L.",
      rating: 4,
      date: "2 weeks ago", 
      text: "Great service and very organized. The camera scanning feature saved me so much time. Highly recommend!",
      verified: true
    },
    {
      id: 4,
      author: "David K.",
      rating: 5,
      date: "3 weeks ago",
      text: "Outstanding package management service. The staff is friendly and the technology they use is top-notch.",
      verified: true
    }
  ]);

  const [averageRating, setAverageRating] = useState(0);

  useEffect(() => {
    const total = reviews.reduce((sum, review) => sum + review.rating, 0);
    setAverageRating((total / reviews.length).toFixed(1));
  }, [reviews]);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`fas fa-star ${
          i < rating ? 'text-yellow-400' : 'text-gray-300'
        }`}
      />
    ));
  };

  const handleLeaveReview = () => {
    // Direct link to Ashop Rotterdam Google Business for reviews
    const googleReviewUrl = `https://search.google.com/local/writereview?placeid=ChIJveXXvYDauEmsRvqDgXL0qbWI`;
    window.open(googleReviewUrl, '_blank');
  };

  return (
    <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100 mt-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-2xl flex items-center justify-center">
            <i className="fas fa-star text-white text-xl"></i>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-800">Customer Reviews</h3>
            <div className="flex items-center space-x-2">
              <div className="flex space-x-1">
                {renderStars(Math.round(averageRating))}
              </div>
              <span className="font-semibold text-gray-700">{averageRating}</span>
              <span className="text-gray-500">({reviews.length} reviews)</span>
            </div>
          </div>
        </div>
        
        <button
          onClick={handleLeaveReview}
          className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-xl hover:from-blue-600 hover:to-purple-600 transform hover:scale-105 transition-all duration-300 flex items-center space-x-2"
        >
          <i className="fas fa-star"></i>
          <span>Write Review</span>
        </button>
      </div>

      {/* Google Business Info */}
      <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-200">
        <div className="flex items-center space-x-3">
          <i className="fab fa-google text-blue-600 text-2xl"></i>
          <div>
            <h4 className="font-semibold text-gray-800">Ashop Package Service</h4>
            <p className="text-sm text-gray-600">Verified Google Business • Professional Package Management</p>
          </div>
        </div>
      </div>

      {/* Reviews List */}
      <div className="space-y-4">
        {reviews.map((review) => (
          <div key={review.id} className="border-b border-gray-100 pb-4 last:border-b-0">
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center text-white font-semibold">
                  {review.author.charAt(0)}
                </div>
                <div>
                  <div className="flex items-center space-x-2">
                    <h5 className="font-semibold text-gray-800">{review.author}</h5>
                    {review.verified && (
                      <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">
                        <i className="fas fa-check-circle mr-1"></i>
                        Verified
                      </span>
                    )}
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex space-x-1">
                      {renderStars(review.rating)}
                    </div>
                    <span className="text-sm text-gray-500">{review.date}</span>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-gray-700 ml-13">{review.text}</p>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="mt-6 text-center p-4 bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl">
        <p className="text-sm text-gray-600 mb-3">
          <i className="fas fa-heart text-red-500 mr-2"></i>
          Love our service? Help others discover Ashop!
        </p>
        <button
          onClick={handleLeaveReview}
          className="inline-flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-medium rounded-lg hover:from-yellow-600 hover:to-orange-600 transition-all duration-300"
        >
          <i className="fab fa-google"></i>
          <span>Leave Google Review</span>
          <i className="fas fa-external-link-alt text-sm"></i>
        </button>
      </div>
    </div>
  );
};

export default GoogleReviews;